import { useIdSeed } from '@atlaskit/ds-lib/use-id';

/**
 * Generates unique ID.
 */
export default function useUniqueId(prefix, shouldRenderId) {
  const seed = useIdSeed();
  return shouldRenderId ? `${seed(prefix)}` : undefined;
}